import posthog from 'posthog-js';

const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;

if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: '/ingest',
    defaults: '2026-01-30',
    disable_session_recording: true,
  });
}
